import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { NgxSmartModalComponent, NgxSmartModalService } from 'ngx-smart-modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { AbstractBaseComponent } from 'src/app/model/AbstractBaseComponent';
import { SharedService } from 'src/app/shared/shared.service';

import {
  LaboratorioLezioneTutoraggioDTO,
  ListLaboratorioLezioneTutoraggioDTO,
  SelectDTO,
} from './../../../../model/newModel';
import { ALaboratorioLezioneTutoraggioService } from './../a-laboratorio-lezione-tutoraggio.service';

@Component({
  selector: 'app-list-laboratori-lezione-tutoraggio',
  templateUrl: './list-laboratori-lezione-tutoraggio.component.html',
  styleUrls: ['./list-laboratori-lezione-tutoraggio.component.css'],
})
export class ListLaboratorioLezioneTutoraggioComponent
  extends AbstractBaseComponent
  implements AfterViewInit, OnInit, OnDestroy {
  options = {
    format: 'DD/MM/YYYY',
  };
  isTutor: boolean;
  listLaboratorioLezioneTutoraggio: ListLaboratorioLezioneTutoraggioDTO;
  tipologieAbilitatoDisabilitato: SelectDTO[];
  abilitatoDisabilitato: string;
  dataSelected: Date;
  tempListLaboratorioLezioneTutoraggio: LaboratorioLezioneTutoraggioDTO[];
  showLaboratori: boolean;
  idTutor: string;
  mostraTutti = false;
  tutors: SelectDTO[];
  idSessione: string;
  sessioni: SelectDTO[];

  ngOnInit(): void {
    this.tipologieAbilitatoDisabilitato = this.sharedService.allSelectTipologieAbilitatoDisabilitato();
    super.ngOnInit();
    this.loadTutors();
    this.loadSessioni();
    this.getSessioneOlaAttiva()
  }

  loadTutors() {
    this.sharedService.selectTutors().subscribe(
      (result) => {
        this.tutors = _.orderBy(result.list, 'viewValue', 'asc');
        if (!!this.tutors) {
          this.idTutor = _.first(this.tutors).value;
        }
      },
      (error) => {
        console.log('Errore selectTutors');
      }
    );
  }


  loadSessioni() {
    this.sharedService.selectSessioniOla(false).subscribe(
      (result) => {
        this.sessioni = _.orderBy(result.list, 'viewValue', 'asc');
        if (!!this.sessioni) {
          this.idSessione = _.first(this.sessioni).value;
        }
      },
      (error) => {
        console.log('Errore selectSessioni');
      }
    );
  }


  search(
    idTutorSelected: string,
    idSesssioneSelected: string,
    abilitatoDisabilitato: string,
    dataSelected: Date
  ) {
    this.spinner.show();
    this.aLaboratorioLezioneTutoraggioService
      .search(
        idTutorSelected,
        idSesssioneSelected,
        abilitatoDisabilitato,
        dataSelected,
        this.mostraTutti
      )
      .subscribe(
        (result) => {
          this.listLaboratorioLezioneTutoraggio = result;
          if (
            this.listLaboratorioLezioneTutoraggio.laboratoriLezioneTutoraggio
              .length > 0
          ) {
            this.showLaboratori = true;
          } else {
            this.showLaboratori = false;
          }
          this.tempListLaboratorioLezioneTutoraggio = Object.assign(
            [],
            this.listLaboratorioLezioneTutoraggio.laboratoriLezioneTutoraggio
          );
          this.spinner.hide();
        },
        (error) => {
          this.spinner.hide();
          console.log('Errore search');
        }
      );
  }

  goToLaboratorioLezioneTutoraggioEditDetail(
    idLaboratorioLezioneTutoraggio: number
  ) {
    this.router.navigate(['/a-laboratorio-lezione-tutoraggio/modifica'], {
      queryParams: {
        idLaboratorioLezioneTutoraggio,
      },
    });
  }

  goToLaboratorioDetail(idLaboratorioLezioneTutoraggio: number) {
    this.router.navigate(['/a-laboratorio-lezione-tutoraggio/dettaglio'], {
      queryParams: {
        idLaboratorioLezioneTutoraggio,
      },
    });
  }

  getSessioneOlaAttiva() {
    this.sharedService.getSessioneOlaActive().subscribe(
      (result) => {
        this.idSessione = '' + result.id;
      },
      (error) => {
        console.log('Errore getSessioneOlaActive');
      }
    );
  }

  disabilita(id: number) {
    this.aLaboratorioLezioneTutoraggioService
      .abilitaDisabilita(id, false)
      .subscribe((result) => {
        if (result) {
          this.sharedService.openOkModal();
          this.modalSubscribe = this.ngxSmartModalService
            .getModal('okModal')
            .onClose.subscribe((modal: NgxSmartModalComponent) => {
              this.search(
                this.idTutor,
                this.idSessione,
                this.abilitatoDisabilitato,
                this.dataSelected
              );
            });
        }
      });
  }

  disabilitaAbilita(id: number, value: boolean) {
    if (value) {
      this.disabilita(id);
    } else {
      this.abilita(id);
    }
  }

  abilita(id: number) {
    this.aLaboratorioLezioneTutoraggioService
      .abilitaDisabilita(id, true)
      .subscribe((result) => {
        if (result) {
          this.sharedService.openOkModal();
          this.modalSubscribe = this.ngxSmartModalService
            .getModal('okModal')
            .onClose.subscribe((modal: NgxSmartModalComponent) => {
              this.search(
                this.idTutor,
                this.idSessione,
                this.abilitatoDisabilitato,
                this.dataSelected
              );
            });
        }
      });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  constructor(
    public ngxSmartModalService: NgxSmartModalService,
    public router: Router,
    private sharedService: SharedService,
    private spinner: NgxSpinnerService,
    private aLaboratorioLezioneTutoraggioService: ALaboratorioLezioneTutoraggioService
  ) {
    super();
  }

  // // QUESTO METODO VIENE USATO PER IL NEXT PAGE MA SOLO SE SONO AMMINISTRATORE
  // nextPage(abilitatoDisabilitato: string, dataSelected: Date, skip: number, take: number, count: number) {
  //   this.aLaboratorioLezioneTutoraggioService.nextPage(abilitatoDisabilitato, dataSelected, skip, take, count).subscribe(result => {
  //     this.listLaboratorioLezioneTutoraggio = result;
  //   }, error => {
  //     console.log('Errore search next');
  //   });
  // }

  // // QUESTO METODO VIENE USATO PER IL PREVIOUS PAGE MA SOLO SE SONO AMMINISTRATORE
  // previousPage(abilitatoDisabilitato: string, dataSelected: Date, skip: number, take: number) {
  //   this.aLaboratorioLezioneTutoraggioService.previousPage(abilitatoDisabilitato, dataSelected, skip, take).subscribe(result => {
  //     this.listLaboratorioLezioneTutoraggio = result;
  //   }, error => {
  //     console.log('Errore search previous');
  //   });
  // }
}
